import { Brand } from "types/common";

export const BrandNameMap = {
  [Brand.Very]: "Very",
  [Brand.VeryIE]: "Very",
  [Brand.Littlewoods]: "Littlewoods",
};
